import { Wind } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const testUsamljenosti: QuizConfig = {
  id: "test-usamljenosti",
  illustration: {
    src: "/images/quizzes/test-usamljenosti.webp",
    alt: "Muškarac sedi sam u kafeu pored prazne stolice.",
  },
  lastModified: "2026-10-05",
  title: "Test usamljenosti: Koliko si zapravo sam/a?",
  shortTitle: "Test usamljenosti",
  description:
    "Besplatan test usamljenosti - otkrij da li te usamljenost opterećuje i kako da se postepeno ponovo povežeš.",
  longDescription:
    "Ovaj test meri nivo usamljenosti i osećaj povezanosti sa drugima. Saznaćeš da li ti više nedostaje bliskost, društveni krug ili osećaj da te neko razume. Na kraju dobijaš praktične korake kako da se ponovo povežeš i smanjiš osećaj izolacije.",
  icon: Wind,
  duration: "3-5 min",
  category: "Odnosi i komunikacija",
  relatedDirectorySlugs: ["usamljenost", "odnosi"],
  focusAreasWanted: [
    "loneliness",
    "relationships",
    "self_development",
    "identity",
  ],
  questions: [
    {
      type: "radio",
      question: "Koliko često osećaš da ti nedostaje društvo?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Koliko često se osećaš isključen/a ili izostavljen/a od drugih?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question:
        "Koliko često osećaš da pripadaš nekoj grupi ljudi (prijatelji, kolege, zajednica)?",
      options: ["Skoro uvek", "Često", "Ponekad", "Retko", "Nikad"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Koliko često se osećaš kao da nemaš kome da se obratiš?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Koliko često se povlačiš od drugih?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question: "Koliko često se osećaš kao da te niko ne razume?",
      options: ["Nikad", "Retko", "Ponekad", "Često", "Skoro uvek"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question: "Koje vrste usamljenosti osećaš? (označi sve što važi)",
      options: [
        "Nedostaje mi bliska, intimna veza sa nekim",
        "Nedostaje mi društveni krug i zajednica",
        "Osećam se nerazumevano čak i oko drugih",
        "Teško mi je da započnem nova prijateljstva",
        "Većina mojih prijateljstava je površna",
        "Ništa od ovoga",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Koliko često radiš stvari sa drugim ljudima ili učestvuješ u grupama?",
      options: [
        "Redovno (nekoliko puta nedeljno)",
        "Često (jednom nedeljno)",
        "Ponekad (nekoliko puta mesečno)",
        "Retko (jednom mesečno ili manje)",
        "Nikad",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "textarea",
      question:
        "Koja je jedna stvar koju možeš da uradiš da se osećaš manje usamljeno?",
    },
  ],
  copy: {
    title: "Tvoj nivo usamljenosti",
    subtitle: "Razumevanje tvog osećaja usamljenosti",
    scoreLabel: "Tvoj rezultat:",
    adviceTitle: "Saveti za izlazak iz usamljenosti",
    resourcesTitle: "Korisni resursi",
    whatNextTitle: "Šta dalje",
    shareButtonText: "Podeli rezultat",
  },
};
